var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._g(_vm._b({ref:"modal"},'b-modal',_vm.$attrs,false),_vm.$listeners),[(!_vm.isEducational)?_vm._t("default"):_c('educational-unavailable',{attrs:{"variant":_vm.variant}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }